/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './Root';
import "./assets/fonts/century-gothic/fonts.scss";
import "../node_modules/slick-carousel/slick/slick.css";
import "../node_modules/slick-carousel/slick/slick-theme.css";
import './styles/bootstrap.scss';
import '../node_modules/font-awesome/scss/font-awesome.scss';
import '../node_modules/react-datepicker/dist/react-datepicker.min.css';
import '../node_modules/sweetalert/dist/sweetalert.css';
import '../node_modules/input-moment/dist/input-moment.css';
import './styles/styles.scss'; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
require('./favicon.ico'); // Tell webpack to load favicon.ico

import initialState from './reducers/initialState';
const store = configureStore(initialState);

render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./Root', () => {
    const NewRoot = require('./Root').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('app')
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js